{
  "replaceMessage": "Değiştirmek için dosyayı bırakın"
}
